import { DisplayFromFHIRAnnotation } from "../datatypeComponents/AnnotationEntry";
import { DisplayFromFHIRAttester } from "../datatypeComponents/AttesterEntry";
import { displayStringFromFHIRBoolean } from "../datatypeComponents/BooleanEntry";
import { DisplayFromFHIRCodeableConcept, getCodeableConceptDisplayForObjectOrArray, simpleDisplayStringFromFHIRCodeableConcept } from "../datatypeComponents/CodeableConceptEntry";
import { CodingDisplay } from "../datatypeComponents/CodingEntry";
import { DisplayFromFHIRContactDetail } from "../datatypeComponents/ContactDetailEntry";
import { DisplayFromFHIRExtendedContactDetail } from "../datatypeComponents/ExtendedContactDetailEntry";
import { displayStringFromFHIRIdentifier } from "../datatypeComponents/IdentifierEntry";
import { DisplayFromFHIRMarkdown } from "../datatypeComponents/MarkdownEntry";
import { displayStringFromFHIRPeriod, getDateDisplay, getDateTimeDisplay } from "../datatypeComponents/PeriodEntry";
import { DisplayFromFHIRReference } from "../datatypeComponents/ReferenceEntry";
import { DisplayFromFHIRRelatedArtifact } from "../datatypeComponents/RelatedArtifactEntry";
import { DisplayFromFHIRRelatesTo } from "../datatypeComponents/RelatesToEntry";
import { DisplayFromFHIRUsageContext } from "../datatypeComponents/UsageContextEntry";
import { languageCodeDisplay } from "../dictionaries/CodeSystemLookup";
import ProfilesByResourceType from "../dictionaries/ProfilesByResourceType";

const displayProfileName = (profile, resourceType) => {
  let profileName;
  const profileDictionary = ProfilesByResourceType[resourceType];
  for (const key in profileDictionary) {
    if (profileDictionary[key].url === profile) {
      profileName = key;
    }
  }
  return profileName || profile;
}

const MetadataPatternDisplay = ({ fhirJson }) => {
  let title = "";
  if (fhirJson.title) {
    title = fhirJson.title;
  }
  let name = "";
  if (fhirJson.name) {
    name = fhirJson.name;
  }
  let url = "";
  if (fhirJson.url) {
    url = fhirJson.url;
  }
  let identifier = [];
  if (fhirJson.identifier) {
    identifier = JSON.parse(JSON.stringify(fhirJson.identifier));
  }
  let profile = [];
  if (fhirJson.meta?.profile) {
    profile = fhirJson.meta.profile;
  }
  let version = "";
  if (fhirJson.version) {
    version = fhirJson.version;
  }
  let versionAlgorithmString = "";
  if (fhirJson.versionAlgorithmString) {
    versionAlgorithmString = fhirJson.versionAlgorithmString;
  }
  let status = "";
  if (fhirJson.status) {
    status = fhirJson.status;
  }
  let experimental = null;
  if (typeof fhirJson.experimental === "boolean") {
    experimental = fhirJson.experimental;
  }
  let date = "";
  if (fhirJson.date) {
    date = fhirJson.date;
  }
  let publisher = "";
  if (fhirJson.publisher) {
    publisher = fhirJson.publisher;
  }
  let contact = [];
  if (fhirJson.contact) {
    contact = JSON.parse(JSON.stringify(fhirJson.contact));
  }
  let extendedContact = [];
  let custodian = "";
  if (fhirJson.custodian) {
    custodian = JSON.parse(JSON.stringify(fhirJson.custodian));
  }
  let description = "";
  if (fhirJson.description) {
    description = fhirJson.description;
  }
  let useContext = [];
  if (fhirJson.useContext) {
    useContext = JSON.parse(JSON.stringify(fhirJson.useContext));
  }
  let jurisdiction = [];
  if (fhirJson.jurisdiction) {
    jurisdiction = JSON.parse(JSON.stringify(fhirJson.jurisdiction));
  }
  let purpose = "";
  if (fhirJson.purpose) {
    purpose = fhirJson.purpose;
  }
  let copyright = "";
  if (fhirJson.copyright) {
    copyright = fhirJson.copyright;
  }
  let copyrightLabel = "";
  if (fhirJson.copyrightLabel) {
    copyrightLabel = fhirJson.copyrightLabel;
  }
  let approvalDate = "";
  if (fhirJson.approvalDate) {
    approvalDate = fhirJson.approvalDate;
  }
  let lastReviewDate = "";
  if (fhirJson.lastReviewDate) {
    lastReviewDate = fhirJson.lastReviewDate;
  }
  let publicationDate = "";
  let publicationStatus = "";
  let effectivePeriod = "";
  if (fhirJson.effectivePeriod) {
    effectivePeriod = fhirJson.effectivePeriod;
  }
  let topic = [];
  if (fhirJson.topic) {
    topic = JSON.parse(JSON.stringify(fhirJson.topic));
  }
  let author = [];
  if (fhirJson.author) {
    author = JSON.parse(JSON.stringify(fhirJson.author));
  }
  if (fhirJson.resourceType === "List" && fhirJson.source) {
    author.push({ "name": fhirJson.source.display });
  }
  let reviewer = [];
  if (fhirJson.reviewer) {
    reviewer = JSON.parse(JSON.stringify(fhirJson.reviewer));
  }
  let editor = [];
  if (fhirJson.editor) {
    editor = JSON.parse(JSON.stringify(fhirJson.editor));
  }
  let endorser = [];
  if (fhirJson.endorser) {
    endorser = JSON.parse(JSON.stringify(fhirJson.endorser));
  }
  let recorder = [];
  if (fhirJson.recorder) {
    recorder = JSON.parse(JSON.stringify(fhirJson.recorder));
  }
  let relatedArtifact = [];
  let relatesTo = [];
  if (fhirJson.relatedArtifact) {
    relatedArtifact = JSON.parse(JSON.stringify(fhirJson.relatedArtifact));
  }
  if (fhirJson.relatesTo) {
    relatesTo = JSON.parse(JSON.stringify(fhirJson.relatesTo));
  }
  let attester = [];
  if (Array.isArray(fhirJson.attester) && fhirJson.attester.length > 0) {
    attester = JSON.parse(JSON.stringify(fhirJson.attester));
  }
  let note = [];
  if (Array.isArray(fhirJson.note) && fhirJson.note.length > 0) {
    note = JSON.parse(JSON.stringify(fhirJson.note));
  }
  let additionalLanguages = [];
  if (Array.isArray(fhirJson.extension) && fhirJson.extension.length > 0) {
    for (const extension of fhirJson.extension) {
      let valueRelatesTo = {};
      switch (extension.url) {
        case 'http://hl7.org/fhir/StructureDefinition/additional-language':
          additionalLanguages.push(extension.valueCode);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-title':
          title = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-name':
          name = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-url':
          url = extension.valueUri;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-identifier':
          identifier.push(extension.valueIdentifier);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-version':
          version = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-versionAlgorithm':
          versionAlgorithmString = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-status':
          status = extension.valueCode;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-experimental':
          experimental = extension.valueBoolean;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-date':
          date = extension.valueDateTime;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-publisher':
          publisher = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-contact':
          contact.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-extended-contact-detail':
          extendedContact.push(extension.valueExtendedContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-description':
          description = extension.valueMarkdown;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-useContext':
          useContext.push(extension.valueUsageContext);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-jurisdiction':
          jurisdiction.push(extension.valueCodeableConcept);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-purpose':
          purpose = extension.valueMarkdown;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-copyright':
          copyright = extension.valueMarkdown;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-copyrightLabel':
          copyrightLabel = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-approvalDate':
          approvalDate = extension.valueDate;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-lastReviewDate':
          lastReviewDate = extension.valueDate;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-publicationDate':
          publicationDate = extension.valueDate;
          break;
        case 'http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status':
          publicationStatus = extension.valueCodeableConcept;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-effectivePeriod':
          effectivePeriod = extension.valuePeriod;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-topic':
          topic.push(extension.valueCodeableConcept);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-author':
          author.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-reviewer':
          reviewer.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-editor':
          editor.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-endorser':
          endorser.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-recorder':
          recorder.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-relatedArtifact':
          relatedArtifact.push(extension.valueRelatedArtifact);
          break;
        case 'http://hl7.org/fhir/uv/ebm/StructureDefinition/relates-to':
          for (let ext of extension.extension) {
            if (ext.url === "type") {
              valueRelatesTo["type"] = ext.valueCode;
            }
            if (ext.url === "targetUri") {
              valueRelatesTo["targetUri"] = ext.valueUri;
            }
            if (ext.url === "targetAttachment") {
              valueRelatesTo["targetAttachment"] = ext.valueAttachment;
            }
            if (ext.url === "targetCanonical") {
              valueRelatesTo["targetCanonical"] = ext.valueCanonical;
            }
            if (ext.url === "targetReference") {
              valueRelatesTo["targetReference"] = ext.valueReference;
            }
            if (ext.url === "targetMarkdown") {
              valueRelatesTo["targetMarkdown"] = ext.valueMarkdown;
            }
          }
          relatesTo.push(valueRelatesTo);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/note':
          note.push(extension.valueAnnotation);
          break;
        default:
        //
      }
    }
  }
  if (Array.isArray(fhirJson.modifierExtension) && fhirJson.modifierExtension.length > 0) {
    for (const extension of fhirJson.modifierExtension) {
      switch (extension.url) {
        case 'http://hl7.org/fhir/StructureDefinition/artifact-title':
          title = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-name':
          name = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-url':
          url = extension.valueUri;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-identifier':
          identifier.push(extension.valueIdentifier);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-version':
          version = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-versionAlgorithm':
          versionAlgorithmString = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-status':
          status = extension.valueCode;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-experimental':
          experimental = extension.valueBoolean;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-date':
          date = extension.valueDateTime;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-publisher':
          publisher = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-contact':
          contact.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-extended-contact-detail':
          extendedContact.push(extension.valueExtendedContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-description':
          description = extension.valueMarkdown;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-useContext':
          useContext.push(extension.valueUsageContext);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-jurisdiction':
          jurisdiction.push(extension.valueCodeableConcept);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-purpose':
          purpose = extension.valueMarkdown;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-copyright':
          copyright = extension.valueMarkdown;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-copyrightLabel':
          copyrightLabel = extension.valueString;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-approvalDate':
          approvalDate = extension.valueDate;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-lastReviewDate':
          lastReviewDate = extension.valueDate;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-effectivePeriod':
          effectivePeriod = extension.valuePeriod;
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-topic':
          topic.push(extension.valueCodeableConcept);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-author':
          author.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-reviewer':
          reviewer.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-editor':
          editor.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-endorser':
          endorser.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-recorder':
          recorder.push(extension.valueContactDetail);
          break;
        case 'http://hl7.org/fhir/StructureDefinition/artifact-relatedArtifact':
          relatedArtifact.push(extension.valueRelatedArtifact);
          break;
        default:
        //
      }
    }
  }

  return <div>
    {title && <p><b>Title: </b>{title}</p>}
    {fhirJson.subtitle && <p><b>Subtitle: </b>{fhirJson.subtitle}</p>}
    {name && <p><b>Name: </b>{name}</p>}
    {url && <p><b>URL: </b>{url}</p>}
    {(Array.isArray(identifier) && identifier.length === 1) && <p><b>Identifier: </b>{displayStringFromFHIRIdentifier(identifier[0])}</p>}
    {(Array.isArray(identifier) && identifier.length > 1) && <p><b>Identifiers: </b>{identifier.map((identifierInstance, identifierIndex) => displayStringFromFHIRIdentifier(identifierInstance)).join(', ')}</p>}
    {(Array.isArray(profile) && profile.length === 1) && <p><b>Profile: </b>{displayProfileName(profile[0], fhirJson.resourceType)}</p>}
    {(Array.isArray(profile) && profile.length > 1) && <p><b>Profiles: </b>{profile.map((profileInstance, profileIndex) => displayProfileName(profileInstance, fhirJson.resourceType)).join(', ')}</p>}
    {fhirJson.language && <p><b>Language: </b>{languageCodeDisplay[fhirJson.language]}</p>}
    {additionalLanguages.length > 0 && additionalLanguages.map((additionalLanguage, index) => {
      return <p key={index}><b>Additional Language: </b>{languageCodeDisplay[additionalLanguage]}</p>
    })}
    {fhirJson.type && <p><b>Type: </b>{simpleDisplayStringFromFHIRCodeableConcept(fhirJson.type)}</p>}
    {(fhirJson.category && fhirJson.resourceType !== "EvidenceVariable") && 
    <p><b>Category: </b>{getCodeableConceptDisplayForObjectOrArray(fhirJson.category)}</p>}
    {(Array.isArray(fhirJson.subject) && fhirJson.subject.length > 0) && fhirJson.subject.map((subject, subjectIndex) => {
      return <div key={subjectIndex}>
        <div><b>Subject: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRReference reference={subject} /></div></div>
      </div>
    })}
    {version && <p><b>Version: </b>{version}</p>}
    {versionAlgorithmString && <p><b>Version Algorithm: </b>{versionAlgorithmString}</p>}
    {fhirJson.versionAlgorithmCoding && <p><b>Version Algorithm: </b><CodingDisplay coding={fhirJson.versionAlgorithmCoding} /></p>}
    {status && <p><b>Status: </b>{status}</p>}
    {(typeof experimental === "boolean") && <p><b>Experimental: </b>{displayStringFromFHIRBoolean(experimental)}</p>}
    {custodian && <span><b>Custodian/Publisher: </b><DisplayFromFHIRReference reference={custodian} /></span>}
    {publisher && <p><b>Publisher: </b>{publisher}</p>}
    {Array.isArray(contact) && contact.map((contactInstance, contactIndex) => {
      return <div key={contactIndex}><div><b>Publisher Contact: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={contactInstance} /></div></div></div>
    })}
    {Array.isArray(extendedContact) && extendedContact.map((contactInstance, contactIndex) => {
      return <div key={contactIndex}><div><b>Extended Contact: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRExtendedContactDetail extendedContactDetail={contactInstance} /></div></div></div>
    })}
    {description && <div><b>Description: </b><DisplayFromFHIRMarkdown markdown={description} /><br /><br /></div>}
    {(Array.isArray(useContext) && useContext.length === 1) && <div><b>Use Context: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRUsageContext usageContext={useContext[0]} /></div><br /></div>}
    {(Array.isArray(useContext) && useContext.length > 1) && useContext.map((useContextInstance, useContextIndex) => {
      return <div key={useContextIndex}><div><b>Use Context: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRUsageContext usageContext={useContextInstance} /></div></div><br /></div>
    })}
    {(Array.isArray(jurisdiction) && jurisdiction.length === 1) && <p><b>Jurisdiction: </b><DisplayFromFHIRCodeableConcept codeableConcept={jurisdiction[0]} /></p>}
    {(Array.isArray(jurisdiction) && jurisdiction.length > 1) && jurisdiction.map((jurisdictionInstance, jurisdictionIndex) => {
      return <div key={jurisdictionIndex}><div><b>Jurisdiction: </b><DisplayFromFHIRCodeableConcept codeableConcept={jurisdictionInstance} /></div></div>
    })}
    {purpose && <div><b>Purpose: </b><DisplayFromFHIRMarkdown markdown={purpose} /><br /><br /></div>}
    {fhirJson.resourceType === "Citation" && <>
      {fhirJson.classification?.length && fhirJson.classification.map((classification, classificationIndex) => {
        return <div key={classificationIndex}>
          <div>
            <b>{classification.type ? simpleDisplayStringFromFHIRCodeableConcept(classification.type) : "Classification"}: </b>
            {classification.classifier && getCodeableConceptDisplayForObjectOrArray(classification.classifier)}
          </div>
        </div>
      })}
      {fhirJson.currentState?.length > 0 && <div>
        <b>Citation Status: </b>
        {getCodeableConceptDisplayForObjectOrArray(fhirJson.currentState)}
      </div>
      }
      {fhirJson.statusDate?.length > 0 && fhirJson.statusDate.map((statusDate, statusDateIndex) => {
        return <div key={statusDateIndex}>
          <div>
            <b>Citation Status: </b>
            {statusDate.activity && simpleDisplayStringFromFHIRCodeableConcept(statusDate.statusDate)}
            {statusDate.actual === true && <b>  Actual  </b>}
            {statusDate.actual === false && <b>  Expected  </b>}
            {statusDate.period && displayStringFromFHIRPeriod(statusDate.period)}
          </div>
        </div>
      })}
    </>}
    {fhirJson.usage && <div><b>Usage: </b><DisplayFromFHIRMarkdown markdown={fhirJson.usage} /></div>}
    {(Array.isArray(note) && note.length === 1) && <div><b>Note: </b><DisplayFromFHIRAnnotation annotation={note[0]} /><br /><br /></div>}
    {(Array.isArray(note) && note.length > 1) && note.map((noteInstance, noteIndex) => {
      return <div key={noteIndex}><div><b>Note: </b><DisplayFromFHIRAnnotation annotation={noteInstance} /></div></div>
    })}
    {copyright && <div><b>Copyright: </b><DisplayFromFHIRMarkdown markdown={copyright} /><br /><br /></div>}
    {copyrightLabel && <p><b>Copyright: </b>{copyrightLabel}</p>}
    {date && <p><b>Date last changed: </b>{getDateTimeDisplay(date)}</p>}
    {approvalDate && <p><b>Date approved: </b>{getDateDisplay(approvalDate)}</p>}
    {lastReviewDate && <p><b>Date last reviewed: </b>{getDateDisplay(lastReviewDate)}</p>}
    {publicationDate && <p><b>Date published: </b>{getDateDisplay(publicationDate)}</p>}
    {publicationStatus && <p><b>Publication status: </b>{simpleDisplayStringFromFHIRCodeableConcept(publicationStatus)}</p>}
    {effectivePeriod && <p><b>Effective period: </b>{displayStringFromFHIRPeriod(effectivePeriod)}</p>}
    {(Array.isArray(topic) && topic.length === 1) && <p><b>Topic: </b><DisplayFromFHIRCodeableConcept codeableConcept={topic[0]} /></p>}
    {(Array.isArray(topic) && topic.length > 1) && topic.map((topicInstance, topicIndex) => {
      return <div key={topicIndex}><div><b>Topic: </b><DisplayFromFHIRCodeableConcept codeableConcept={topicInstance} /></div></div>
    })}
    {(fhirJson.resourceType === "Composition" || fhirJson.resourceType === "DocumentReference") ?
      <>
        {(Array.isArray(author) && author.length === 1) &&
          <div><b>Author: </b>
            <>{author[0].name ?
              <div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={author[0]} /></div>
              :
              <div style={{ marginLeft: "24px" }}><DisplayFromFHIRReference reference={author[0]} /></div>
            }</>
            <br />
          </div>
        }
        {(Array.isArray(author) && author.length > 1) && author.map((contact, contactIndex) => {
          return <div key={contactIndex}><div><b>Author: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRReference reference={contact} /></div></div></div>
        })}
        {(Array.isArray(attester) && attester.length === 1) && <div><b>Attester: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRAttester attester={attester[0]} /></div><br /></div>}
        {(Array.isArray(attester) && attester.length > 1) && attester.map((attester, attesterIndex) => {
          return <div key={attesterIndex}><div><b>Attester: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRAttester attester={attester} /></div></div></div>
        })}
      </>
      :
      <>
        {(Array.isArray(author) && author.length === 1) && <div><b>Author: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={author[0]} /></div><br /></div>}
        {(Array.isArray(author) && author.length > 1) && author.map((contact, contactIndex) => {
          return <div key={contactIndex}><div><b>Author: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={contact} /></div></div></div>
        })}
        {(Array.isArray(editor) && editor.length === 1) && <div><b>Editor: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={editor[0]} /></div><br /></div>}
        {(Array.isArray(editor) && editor.length > 1) && editor.map((contact, contactIndex) => {
          return <div key={contactIndex}><div><b>Editor: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={contact} /></div></div></div>
        })}
        {(Array.isArray(reviewer) && reviewer.length === 1) && <div><b>Reviewer: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={reviewer[0]} /></div><br /></div>}
        {(Array.isArray(reviewer) && reviewer.length > 1) && reviewer.map((contact, contactIndex) => {
          return <div key={contactIndex}><div><b>Reviewer: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={contact} /></div></div></div>
        })}
        {(Array.isArray(endorser) && endorser.length === 1) && <div><b>Endorser: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={endorser[0]} /></div><br /></div>}
        {(Array.isArray(endorser) && endorser.length > 1) && endorser.map((contact, contactIndex) => {
          return <div key={contactIndex}><div><b>Endorser: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={contact} /></div></div></div>
        })}
        {(Array.isArray(recorder) && recorder.length === 1) && <div><b>Recorder: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={recorder[0]} /></div><br /></div>}
        {(Array.isArray(recorder) && recorder.length > 1) && recorder.map((contact, contactIndex) => {
          return <div key={contactIndex}><div><b>Recorder: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRContactDetail contactDetail={contact} /></div></div></div>
        })}
      </>
    }
    {(Array.isArray(relatedArtifact) && relatedArtifact.length === 1) && <div><b>Related Item: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRRelatedArtifact relatedArtifact={relatedArtifact[0]} /></div></div>}
    {(Array.isArray(relatedArtifact) && relatedArtifact.length > 1) && relatedArtifact.map((relatedItem, relatedItemIndex) => {
      return <div key={relatedItemIndex}><div><b>Related Item: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRRelatedArtifact relatedArtifact={relatedItem} /></div></div></div>
    })}
    {(Array.isArray(relatesTo) && relatesTo.length === 1) && <div><b>Related Item: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRRelatesTo relatesTo={relatesTo[0]} /></div></div>}
    {(Array.isArray(relatesTo) && relatesTo.length > 1) && relatesTo.map((relatedItem, relatedItemIndex) => {
      return <div key={relatedItemIndex}><div><b>Related Item: </b><div style={{ marginLeft: "24px" }}><DisplayFromFHIRRelatesTo relatesTo={relatedItem} /></div></div></div>
    })}
  </div>
}

export { MetadataPatternDisplay };